// extracted by mini-css-extract-plugin
module.exports = {"containerRoot":"styles_containerRoot__7TfeD","containerResult":"styles_containerResult___u2Ee"};